<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
<vs-alert color="danger" title="Course Not Found" :active.sync="course_not_found">
      <span>Course record with id: {{ $route.params.Id }} {{$t('NotFound')}}. </span>
      <span>
        <span>{{$t('Check')}} </span><router-link :to="{name:'Course'}" class="text-inherit underline">All Course</router-link>
      </span>
    </vs-alert>
      

   <div  v-if="!course_not_found||(this.$route.params.ID&&this.courseModel.ID)">
     <vx-card>

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab :label="$t('Main')" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
                 <Course-Tab-Main class="mt-4" :courseModel="courseModel" />
            </div>
          </vs-tab>

          <vs-tab :label="$t('EvaluationMean')" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
                <Course-Tab-Evaluation-Mean class="mt-4"  />
            </div>
          </vs-tab>

          <vs-tab :label="$t('Facility')" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
                <Course-Tab-Facility class="mt-4"  />
            </div>
          </vs-tab>
          
          <vs-tab :label="$t('Modules')" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
               <Course-Tab-Module class="mt-4"  />
            </div>
          </vs-tab>

          <vs-tab :label="$t('Material')" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
               <CourseTabMaterial class="mt-4"  />
            </div>
          </vs-tab>

          <vs-tab :label="$t('Cost')" icon-pack="feather" icon="icon-dollar-sign"> 
            <div class="tab-text">
               <CourseCost class="mt-4" :annualPlanBudgetModel="courseModel.AnnualPlanBudget" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
     <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
           <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{$t('Submit')}}</vs-button>
           <vs-button type="border" color="danger" :to="{name:'Course'}">{{$t('Cancel')}}</vs-button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import CourseTabEvaluationMean     from "./CourseTabEvaluationMean.vue"
import CourseTabMain     from "./CourseTabMain.vue"
import CourseTabFacility     from "./CourseTabFacility.vue"
import CourseTabModule     from "./CourseTabModule.vue"
import CourseTabMaterial     from "./CourseTabMaterial.vue"
import moduleCourse from "@/store/course/moduleCourse.js";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import CourseCost from './Course_Cost.vue'
export default {
  components: {
    CourseCost,
    CourseTabEvaluationMean,
    CourseTabMaterial,
   CourseTabMain,
   CourseTabFacility,
    vSelect,
    VuePerfectScrollbar,
    CourseTabModule
  },
  data() {
    return {
      activePrompt:false,
      selected: [],
      isMounted: false,
      // Data Sidebar
      courseModel: {},
      rowDataForDelete: {},
      activeConfirm: false,
      course_not_found :false,
      activeTab: 0,
    
    };
  },
  computed: {
    isFormValid() {
      return !this.errors.any() && this.courseModel.Name;
    },
      currentPage() {
      debugger
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },

  methods: {

    initValues()
    {
     debugger
       this.courseModel = {};
        this.courseModel.AnnualPlanBudget={};
        this.courseModel.languages = [];
        this.courseModel.industrySectors = [];
        this.courseModel.areaOfStudies = [];
        this.courseModel.populationList = [];
        this.courseModel.trainingStrategy=[];
        this.courseModel.documentations=[];
    },
     initCourseListValues()
    {
      debugger
      this.courseModel.courseEvaluationMeans = [];
        this.courseModel.CourseLanguages = [];
        this.courseModel.CourseIndustrySectors = [];
        this.courseModel.CourseAreas = [];
        this.courseModel.CoursePopulationList = [];
         this.courseModel.CourseTrainingStrategies = [];
          this.courseModel.CourseDocumentations=[];
       
    },
     submitData() {
         
       this.courseModel.CourseFacilities=this.$store.state.courseList.courseFacilities;
        this.courseModel.CourseFacilities=this.$store.state.courseList.courseFacilities; 
        this.courseModel.CourseEvaluationMeans=this.$store.state.courseList.courseEvaluationMeans;

       this.initCourseListValues();
       if(this.courseModel.modes!=null)
          this.courseModel.CourseModes=this.courseModel.modes.map(function(val){ var obj={}; obj.CourseTypeID=val; return obj; });
       if(this.courseModel.languages!=null)
        this.courseModel.CourseLanguages=this.courseModel.languages.map(function(val){ var obj={}; obj.LanguageID=val; return obj; });
       if(this.courseModel.industrySectors!=null)     
           this.courseModel.CourseIndustrySectors=this.courseModel.industrySectors.map(function(val){ var obj={}; obj.IndustrySectorID=val; return obj; });
       if(this.courseModel.areaOfStudies!=null)        
          this.courseModel.CourseAreas=this.courseModel.areaOfStudies.map(function(val){ var obj={}; obj.CourseAreaOfStudyID=val; return obj; });
       if(this.courseModel.populationList!=null)  
          this.courseModel.CoursePopulationList=this.courseModel.populationList.map(function(val){ var obj={}; obj.PopulationListID=val; return obj; });
       if(this.courseModel.trainingStrategy!=null)      
          this.courseModel.CourseTrainingStrategies = this.courseModel.trainingStrategy.map(function(val){ var obj={}; obj.TrainingStrategyID=val; return obj; });
      this.courseModel.CourseModules = this.$store.state.courseList.courseModules;
      this.courseModel.CourseMaterials = this.$store.state.courseList.courseMaterials;
       if(this.courseModel.documentations!=null) 
          this.courseModel.CourseDocumentations=this.courseModel.documentations.map(function(val){ var obj={}; obj.DocumentationID=val; return obj; });
      this.$validator.validateAll().then(result => {
        if (result) {
         
          if (this.courseModel.ID !== null && this.courseModel.ID >= 0) {
            this.$vs.loading();
            this.$store.dispatch("courseList/updateItem", this.courseModel).then(res => { 
                console.error(res);
                this.$vs.loading.close();
    this.$store.state.courseList.search.pageNum=1;
                 this.$router.go(-1);
            
               this.initValues();    
           }).catch(err => {
             this.$vs.loading.close();
              console.error(err);
            });
          
          } else {
            delete this.courseModel.ID;
            this.courseModel.popularity = 0;
            this.$vs.loading();
            this.$store.dispatch("courseList/addItem", this.courseModel) 
            .then(res => { 
                console.error(res);
                this.$vs.loading.close();
           this.$store.state.courseList.search.pageNum=1;
              this.$router.go(-1);
            
               this.initValues();    
           }).catch(err => {
             this.$vs.loading.close();
              console.error(err);
            });
              
          } 
         
        }
      });
    },

  },

  created() {
    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
     const ID = this.$route.params.ID
     this.$store.commit("courseList/SET_CourseFacilities",[]);
      this.$store.commit("courseList/SET_CourseModule", []);
       this.$store.commit("courseList/SET_CourseEvaluationMean",[]);
      this.$store.commit("courseList/SET_CourseMaterial", []);
      this.initValues();
     if(ID!=undefined)
     {

      this.$store.dispatch("courseList/GetItemByID", ID)
      .then(res => {
        debugger
        if(res instanceof Array)
                   this.courseModel = res[0].data;   
                else
                  this.courseModel = res.data; 
        // this.courseModel = res.data;
        this.courseModel.modes= this.courseModel.CourseModes.map(a=>a.CourseTypeID);
        if(!this.courseModel.AnnualPlanBudget)
          this.courseModel.AnnualPlanBudget={};
        this.courseModel.languages= this.courseModel.CourseLanguages.map(a=>a.LanguageID);
        this.courseModel.industrySectors= this.courseModel.CourseIndustrySectors.map(a=>a.IndustrySectorID);
        this.courseModel.areaOfStudies= this.courseModel.CourseAreas.map(a=>a.CourseAreaOfStudyID);
        this.courseModel.populationList= this.courseModel.CoursePopulationList.map(a=>a.PopulationListID);
        this.courseModel.trainingStrategy= this.courseModel.CourseTrainingStrategies.map(a=>a.TrainingStrategyID);
        this.courseModel.documentations= this.courseModel.CourseDocumentations.map(a=>a.DocumentationID);
        this.$store.commit("courseList/SET_CourseFacilities", res.data.CourseFacilities);
        this.$store.commit("courseList/SET_CourseModule", res.data.CourseModules);
        this.$store.commit("courseList/SET_CourseEvaluationMean", res.data.CourseEvaluationMeans);
         this.$store.commit("courseList/SET_CourseMaterial", res.data.CourseMaterials);
        
       })
      .catch(err => {
         
        if(err.response.status === 404) {
          this.course_not_found = true
          return
        }
        console.error(err) 
        })
     }
    
    //this.$store.dispatch("courseList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
